var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasHandles && _vm.products.length > 0)?_c('div',{staticClass:"related-products bg-putty relative py-20"},[_c('ProductCardSlider',{staticClass:"w-full",attrs:{"heading":_vm.$t('product.relatedProducts'),"products":_vm.products}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }